"use client";

import { CircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  id: "1",
  question: "What is freight transportation arrangement?",
  answer: "Freight transportation arrangement is the coordination and management of the full shipping process—from route planning and carrier selection to real-time tracking and compliance documentation—ensuring your cargo moves efficiently and on schedule."
}, {
  id: "2",
  question: "What types of businesses do you serve?",
  answer: "We serve businesses of all sizes, from small manufacturers to large distributors. Whether you ship locally or nationwide, MANAGEMENT 101 LLC tailors logistics solutions to meet your unique requirements."
}, {
  id: "3",
  question: "How do you ensure my shipment arrives on time?",
  answer: "We leverage real-time tracking systems, strategic route planning, and vetted carrier partnerships to minimize delays. Our team monitors every shipment closely and proactively addresses any potential issues."
}, {
  id: "4",
  question: "Do you handle compliance and documentation?",
  answer: "Yes. We manage all necessary compliance documentation, ensuring your freight meets regulatory standards and moves smoothly across jurisdictions without unexpected hold-ups."
}, {
  id: "5",
  question: "How can I get a quote or start working with you?",
  answer: "Contact us at (661) 200-9865 or info@management101llc.com to discuss your shipping needs. We'll provide a detailed consultation and transparent pricing tailored to your business."
}];
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="faq" ref={ref} className="w-full bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className={`mx-auto max-w-3xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-2.5 opacity-0"}`}>
        <div className="mb-12 text-center">
          <h2 className="text-white mb-4 text-3xl font-bold sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="text-white text-base sm:text-lg">
            Find answers to common questions about our freight transportation
            arrangement services.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-border rounded-lg border bg-background px-6 shadow-soft transition-all duration-[var(--duration-medium)] hover:shadow-medium">
              <AccordionTrigger className="group py-5 text-left text-base font-semibold hover:no-underline">
                <div className="flex items-start gap-4">
                  <CircleQuestionMark className="text-primary mt-0.5 size-5 shrink-0 transition-colors group-hover:text-primary-hover" />
                  <span className="text-foreground transition-all group-hover:font-bold">
                    {faq.question}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pl-9 text-sm leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-4 text-sm">
            Still have questions? We're here to help.
          </p>
          <p className="text-foreground text-base font-medium">
            Call us at{" "}
            <Link to="tel:+16612009865" className="text-primary hover:text-primary-hover transition-colors hover:underline">
              (661) 200-9865
            </Link>{" "}
            or email{" "}
            <Link to="mailto:info@management101llc.com" className="text-primary hover:text-primary-hover transition-colors hover:underline">
              info@management101llc.com
            </Link>
          </p>
        </div>
      </div>
    </section>;
}